export default __webpack_public_path__ + "static/media/productList5.3379ceb8.png";